var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfDm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48.041,
    viewBox: "0 0 40 48.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_374",
    "data-name": "Groupe 374",
    transform: "translate(-259.429 -221.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_506-3",
    "data-name": "Groupe 506-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_503-3",
    "data-name": "Groupe 503-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_580",
    "data-name": "Trac\\xE9 580",
    d: "M293.429,269.736h-28a6.006,6.006,0,0,1-6-6v-36a6.007,6.007,0,0,1,6-6h.012c9.436.06,14.747,0,17.6-.028,3.555-.037,3.623-.039,4.274.612.408.407,5.136,6.359,6.05,7.514,6.063,7.662,6.063,7.753,6.063,8.623v25.279A6.007,6.007,0,0,1,293.429,269.736Zm-28-44a2,2,0,0,0-2,2v36a2,2,0,0,0,2,2h28a2,2,0,0,0,2-2V239.03c-1.459-2.04-8.434-10.826-10.492-13.338-.461,0-1.112.008-1.853.016C280.22,225.739,274.889,225.794,265.424,225.736Z",
    fill: "#de4c4a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_510",
    "data-name": "Groupe 510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_581",
    "data-name": "Trac\\xE9 581",
    d: "M268.936,260.173c-.149,0-.3-.005-.447-.014a1,1,0,0,1,.122-2,5.4,5.4,0,0,0,1.462-.113,16.71,16.71,0,0,0,1.16-1.766c.384-.633.782-1.287,1.192-1.879,1.012-1.457,4.3-9.617,4.584-10.666a7.376,7.376,0,0,1,.5-1.179c.928-1.9,1.647-3.747.27-5.347a1,1,0,1,1,1.516-1.3c2.349,2.73.829,5.85.013,7.527a6.971,6.971,0,0,0-.371.829c-.347,1.277-3.693,9.585-4.869,11.28-.383.551-.766,1.184-1.127,1.777-.937,1.544-1.416,2.3-2.037,2.57l-.153.052A7.331,7.331,0,0,1,268.936,260.173Z",
    fill: "#de4c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_582",
    "data-name": "Trac\\xE9 582",
    d: "M287.477,253.865q-.076,0-.153,0c-2.375-.091-4.307-2.243-4.52-2.488-.051-.059-5.185-6.039-5.776-7.993a7.818,7.818,0,0,0-.4-.915c-.761-1.589-2.346-4.9,1.422-6.817a1,1,0,1,1,.908,1.781c-1.748.892-1.586,1.96-.526,4.172a8.931,8.931,0,0,1,.51,1.2c.324,1.072,3.67,5.3,5.372,7.261a5.172,5.172,0,0,0,3.086,1.8,1.943,1.943,0,0,0,1.5-.634,1,1,0,0,1,1.406,1.422A3.964,3.964,0,0,1,287.477,253.865Z",
    fill: "#de4c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_583",
    "data-name": "Trac\\xE9 583",
    d: "M268.522,260.142a.994.994,0,0,1-.669-.258,2.22,2.22,0,0,1-.762-2.084c.505-2.828,6.732-5.4,6.795-5.421.754-.3,2.352-.7,4.2-1.166,1.93-.483,4.117-1.03,5.276-1.464,1.894-.71,5.971-.545,7.045.981a1.581,1.581,0,0,1-.145,2,1,1,0,0,1-1.706-.979,7.459,7.459,0,0,0-4.492-.128c-1.265.473-3.414,1.011-5.492,1.531-1.631.409-3.318.831-3.945,1.082-2.112.847-5.382,2.864-5.57,3.917-.009.051-.02.11.133.248a1,1,0,0,1-.671,1.742Z",
    fill: "#de4c4a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDm);
export default __webpack_public_path__ + "static/media/pdfDM.51cf8cbcb74ea14d32d241e75d37f230.svg";
export { ForwardRef as ReactComponent };